import { styled } from "@l2r-front/l2r-ui"

export const PageWrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
})
